/**
 * The Decide slot registry (ADR-0027 §2). Owner WP13 (skeleton); each slot WP appends ONE line to `decideSlots` and never
 * edits another's: forecastBeat WP24b · bandPicker WP37b · eventsTab WP25 · croCompare WP24c · soloReview WP32.
 * Decide (WP24) renders whatever is registered; an empty slot renders its documented fallback (screens.md §P6), e.g. a
 * guided round with no bandPicker shows "Band picker unavailable". Props carry data and RouteCalls, never the client.
 */
import type { ComponentType } from "react";
import { CallTheYear } from "./forecast/CallTheYear";
import { BandPicker } from "./guided/BandPicker";
import { CroCompare } from "./review/compare/CroCompare";
import { EventsTab } from "../events/EventsTab";
import { SoloReview } from "../solo/SoloReview";
import { AlmView } from "./preview/AlmView";
import { StatementsView } from "./preview/StatementsView";
import { TraceView } from "./preview/TraceView";
import type { BandPickerProps, CallTheYearProps, CroCompareProps, EventsTabProps, PreviewView, SoloReviewProps } from "./slotTypes";

export interface DecideSlots {
  forecastBeat?: ComponentType<CallTheYearProps>;
  bandPicker?: ComponentType<BandPickerProps>;
  eventsTab?: ComponentType<EventsTabProps>;
  croCompare?: ComponentType<CroCompareProps>;
  soloReview?: ComponentType<SoloReviewProps>;
  /** Views beside Headline in the preview panel; none registered means "Headline only". */
  previewViews?: readonly PreviewView[];
}

/** Append-only: one line per slot WP (`forecastBeat: CallTheYear,`). */
export const decideSlots: DecideSlots = {
  forecastBeat: CallTheYear,
  bandPicker: BandPicker,
  eventsTab: EventsTab,
  croCompare: CroCompare,
  soloReview: SoloReview,
  previewViews: [{ id: "trace", label: "Trace", View: TraceView }, { id: "alm", label: "ALM", View: AlmView }, { id: "statements", label: "Statements", View: StatementsView }],
};
